<template>
  <div
    style="
      background-color: #fff;
      border: 1px solid #e0e0e0;
      border-top: 0px;
      border-radius: 0 0 3px 3px;
      padding-top: 12px;
    "
  >
    <div class="margin-subpages">  
      <iframe
          ref="iframeRef"
          id="iframeRef"
          src="https://zapier.com/editor/sandbox/draft/1/setup"
          width="100%"
          class="thin-scrollbar iframe-container">
    </iframe></div>
  </div>
</template>
  
  
  
<script>
export default {
  name: "integrations",
  // components: {
  //   loadingEven: require("../even/loading").default,
  // },
  data() {
    return {};
  },
  mounted() {
    console.log("integrations")
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
  